import {
  useLocation,
  useNavigate,
  useParams,
  useNavigationType,
  useSearchParams,
} from 'react-router-dom';

const withRouter = (Component) => {
  function Wrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const searchParams = useSearchParams();
    const navigateType = useNavigationType();

    return (
      <Component
        navigate={navigate}
        navigateType={navigateType}
        location={location}
        params={params}
        searchParams={searchParams}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }

  return Wrapper;
};

export default withRouter;
